// snackbar.component.ts

import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core'
import { trigger, state, style, transition, animate } from '@angular/animations'
import { SnackbarService } from './snackbar.service'
import { MessageComponent } from '../message'

@Component({
  selector: 'hyperkit-snackbar',
  standalone: true,
  imports: [MessageComponent],
  template: `
    @if (visible()) {
      <div
        class="snackbar"
        [@fadeInOut]="visible() ? 'in' : 'out'"
        >
        <hyperkit-message
          type="success"
          [text]="message()"
          [actionText]="action()?.text"
          [actionCallback]="action()?.callback"
          [closable]="false"
        ></hyperkit-message>
      </div>
    }
    `,
  styles: [
    `
      .snackbar {
        position: fixed;
        bottom: 24px;
        right: 24px;
        border-radius: 0px;
        font-size: 14px;
        font-weight: 500;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        z-index: 9999;
        opacity: 0.95;
      }
    `,
  ],
  animations: [
    trigger('fadeInOut', [
      state(
        'in',
        style({
          opacity: 1,
          transform: 'translateY(0)',
        }),
      ),
      state(
        'out',
        style({
          opacity: 0,
          transform: 'translateY(8px)',
        }),
      ),
      transition('* => in', [
        style({
          opacity: 0,
          transform: 'translateY(8px)',
        }),
        animate(
          '200ms ease-out',
          style({
            opacity: 1,
            transform: 'translateY(0)',
          }),
        ),
      ]),
      transition('in => out', [
        animate(
          '150ms ease-in',
          style({
            opacity: 0,
            transform: 'translateY(8px)',
          }),
        ),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent {
  private readonly snackbar = inject(SnackbarService)

  message = computed(() => this.snackbar.message()?.text ?? '')
  visible = computed(() => !!this.snackbar.message())
  action = computed(() => this.snackbar.message()?.action)
}
